/**
 * Hook for handling processor-specific authentication redirects
 */
import { useCallback } from 'react';
export function useProcessorAuthAction() {
    const handleProcessorAuth = useCallback(async (actionData) => {
        const redirect = actionData.metadata?.redirect;
        if (!redirect?.redirectUrl)
            return;
        if (redirect.method === 'POST') {
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = redirect.redirectUrl;
            if (redirect.data && typeof redirect.data === 'object') {
                Object.entries(redirect.data).forEach(([key, value]) => {
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = key;
                    input.value = String(value);
                    form.appendChild(input);
                });
            }
            document.body.appendChild(form);
            form.submit();
        }
        else {
            window.location.href = redirect.redirectUrl;
        }
    }, []);
    return { handleProcessorAuth };
}
